import { ItemGroupInput } from '@/types/item-group';
import { filterValueToQuery } from '@/api';

export default function itemGroup(axios: any) {
  async function getItemGroups(filter: any) {
    try {
      const response = await axios.get(`/api/item_groups?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/material] getItemGroups Error', e);
    }
    return null;
  }

  async function getItemGroup(id: number) {
    const response = await axios.get(`/api/item_groups/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/material] getItemGroup Error', e);
    }
    return null;
  }

  async function createItemGroup(payload: ItemGroupInput) {
    const response = await axios.post('/api/item_groups', payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/material] createItemGroup Error', e);
    }
    return null;
  }

  async function updateItemGroup(id: number | string, payload: ItemGroupInput) {
    const response = await axios.put(`/api/item_groups/${id}`, payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/material] updateItemGroup Error', e);
    }
    return null;
  }

  async function deleteItemGroup(id: number) {
    const response = await axios.delete(`/api/item_groups/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/material] deleteItemGroup Error', e);
    }
    return null;
  }

  return {
    getItemGroups,
    getItemGroup,
    createItemGroup,
    updateItemGroup,
    deleteItemGroup,
  };
}
